import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { MessageService } from '../message.service';
import { AppDefinition } from '../app-definition';
import { QueryMetaData} from '../query-metadata';
import { AppService } from '../app.service';
import { environment } from '../../environments/environment';
import { PaginationComponent } from '../pagination/pagination.component';

@Component({
    selector: 'app-app-list',
    templateUrl: './app-list.component.html',
    styleUrls: ['./app-list.component.scss'],
    standalone: true,
    imports: [RouterModule, PaginationComponent]
})
export class AppListComponent implements OnInit {

  apps: AppDefinition[];
  selectedApp: AppDefinition;
  queryObj: QueryMetaData;

  private route: ActivatedRoute = inject(ActivatedRoute);
  private appService: AppService = inject(AppService);
  private messageService: MessageService = inject(MessageService);

  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe((params) => {
               const start = params.get('start') === null ? 0 : parseInt(params.get('start'));
               const size = params.get('size') === null ? environment.pageSize : parseInt(params.get('size'));
        this.queryObj = { start, size } as QueryMetaData;
        this.getAppDefinitions(this.queryObj);
      }
    );
  }

  getAppDefinitions(query: QueryMetaData): void {
    this.appService.getAppDefinitions(query)
        .subscribe(apps => this.apps = apps);
  }

  /** Start app instance without any inputs (no start form) */
  onSelect(app: AppDefinition): void {
    this.selectedApp = app;
    this.messageService.set(`App selected id=${app.id}`);
  }
}
